<template>
  <div class="d-flex flex-column">
    <span class="text-capitalize-first">
      {{ helper.trans(`antifraudalerts.rule.${alert.rule}`) }}
    </span>
    <div class="text-danger">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first">{{helper.trans(`antifraudalerts.description.tg_user_change_rule`, {username: data?.tg_user.username ?? data?.tg_user.id})}}</span>
    </div>
    <div class="text-danger text-capitalize-first">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first d-inline-block">{{ helper.trans('labels.trader_blocked') }}</span>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import CopyButton from "@/components/CopyButton.vue";
import TgUserChangeRuleDataDTO from "@/models/AntiFraud/TgUserChangeRuleDataDTO";

export default defineComponent({
  name: "TgUserChangeRuleDescription",
  components: {CopyButton},
  props: {
    alert: {
      type: Object as PropType<AntiFraudAlertDTO>,
      default: null
    } as Prop<AntiFraudAlertDTO>,
  },
  setup(props) {
    const data = computed((): TgUserChangeRuleDataDTO | null => {
      if (!props.alert) {
        return null
      }

      return props.alert.data as unknown as TgUserChangeRuleDataDTO
    })

    return {
      helper,
      numberFormatter,
      data
    }
  }
})
</script>
